<script>
  import { fade } from 'svelte/transition'
  import Fundip from '../core/visual/Fundip.svelte'
  import IntersectionObserver from '../util/IntersectionObserver.svelte'
  import { onMount, beforeUpdate } from 'svelte'

  export let loading
  export let data = undefined
  export let suffix = ''
  export let variant = 'base'
  export let store = undefined
  

  let realData = undefined

  /**
   * If data is an array, we'll assume it's an array of { label: 'something', value: 123 } pairs.
   * If it's an object, we'll assume it's a single flat object with { label: value, ... } inline pairs
  */
  const _processData = ()=>{
    // if store is there, let's do a quick check to make sure it looks like a store.
    if(store && store.hasOwnProperty('subscribe')) {
    } else {
      if(Array.isArray(data)) {
        realData = data
      } else if(typeof data === 'object') {
        const entries = Object.entries(data)
        realData = entries.map((obj)=>{
          return {label:obj[0], value:obj[1]}
        })
      } else {
        console.error('This data is not an object or an array:', data)
      }
    }
  }

  beforeUpdate(()=>{
    if(data) { 
      _processData() 
    }
  })
</script>

{#if $loading}
    LOADING
  {:else}
    <IntersectionObserver class="bar-chart-wrapper" let:intersecting once bottom={ 500 }>
      { #if intersecting }
        <div class="bar-chart-inner" in:fade={{ delay:150 }}>
          <Fundip sticks={ $store } variant={ variant } suffix={ suffix }/>
        </div>
      { :else }
        <div class="min-h-screen"></div>  
      { /if }
  </IntersectionObserver>
{/if}